export default __webpack_public_path__ + "static/media/instagram.95aa1f4e.svg";